import { Target } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useBetting } from '../../../../../../../Context/BettingContext';
import { sendNotfication } from '../../../../../../../Helper';
import { useExposure } from '../../../../../../../hooks/useExposure';

const Container = styled.div`
  width: 100%;
   font-family: 'Montserrat Alternates', sans-serif;
  background: #292d2e;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: rgb(50, 55, 56);
  color: white;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
  font-weight: bold;
  font-size: 10px;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const MatchedInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 10px;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const InfoIcon = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #6E6E6E;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

const ChartIcon = styled.span`
  color: #6E6E6E;
`;

const Table = styled.div`
  width: 100%;
`;

const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  border-bottom: 1px solid rgb(50, 55, 56);
  // background: rgb(50, 55, 56);
   font-family: 'Montserrat Alternates', sans-serif;
`;

const HeaderCell = styled.div`
  width: 90px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-weight: bold;
  color: white;
  border-left: 1px solid rgb(50, 55, 56);
   font-family: 'Montserrat Alternates', sans-serif;
  
  &:first-child {
    width: auto;
    border-left: none;
  }
`;

const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  border-bottom: 1px solid rgb(50, 55, 56);
  background: ${props => props.highlight ? '#292d2e' : '#292d2e'};
   font-family: 'Montserrat Alternates', sans-serif;
`;

const TeamCell = styled.div`
  padding: 12px;
  font-size: 11px;
  color: white;
  display: flex;
  align-items: center;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const OddsCell = styled.div`
  width: 90px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${props => {
    if (props.selected) {
      return props.type === 'back' ? '#72BBEF' : '#FFB6C1';
    }
    return props.type === 'back' ? '#72BBEF' : '#FFB6C1';
  }};
  border-left: 1px solid rgb(50, 55, 56);
  cursor: pointer;
   font-family: 'Montserrat Alternates', sans-serif;

  .odds {
    font-weight: bold;
    font-size: 10px;
    color: black;
  }
  
  .volume {
    font-size: 8px;
    color: black;
  }
`;

// New styled components for bet container
const BetContainer = styled.div`
  padding: 2px 10px;
  background: ${props => props.betType === 'back' ? '#292d2e' : '#292d2e'};
  border-top: 1px solid rgb(50, 55, 56);
  color: white;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const BetInputContainer = styled.div`
  display: flex;
  align-items: stretch;
  height: 40px;
  border: 1px solid rgb(50, 55, 56);
  border-radius: 4px;
  overflow: hidden;
  background: #292d2e;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const AdjustButton = styled.div`
  width: 40px;
  border: none;
  background: rgb(50, 55, 56);
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
   font-family: 'Montserrat Alternates', sans-serif;
  
  &:hover {
    background: rgb(60, 65, 66);
  }

  &:active {
    background: rgb(40, 45, 46);
  }
`;
const BetInputc = styled.input`
  width: 60px;
  text-align: center;
  font-size: 14px;
  padding: 4px;
   border: 1px solid rgb(50, 55, 56);
  border-radius: 4px;
  color: white;
    background: #292d2e;
     font-family: 'Montserrat Alternates', sans-serif;
`;
const BetInput = styled.div`
  flex: 1;
  padding: 8px;
  font-size: 16px;
  text-align: center;
  background: #292d2e;
  color: white;
  display: flex;
  min-width:100px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(50, 55, 56);
   font-family: 'Montserrat Alternates', sans-serif;
`;

const QuickAmounts = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 2px;
  margin-bottom: 8px;
`;

const QuickAmount = styled.div`
  padding: 4px;
  text-align: center;
  background: #292d2e;
  border: 1px solid rgb(50, 55, 56);
  cursor: pointer;
  color: white;
  font-size: 10px;
   font-family: 'Montserrat Alternates', sans-serif;
  
  &:hover {
    background: rgb(50, 55, 56);
  }
`;

const NumberPad = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 2px;
  width: 100%;
`;

const NumberButton = styled.div`
  padding: 12px;
  text-align: center;
  background: #292d2e;
  border: 1px solid rgb(50, 55, 56);
  cursor: pointer;
  color: white;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
   font-family: 'Montserrat Alternates', sans-serif;
  
  &:hover {
    background: rgb(50, 55, 56);
  }
`;

const CrossButton = styled(NumberButton)`
  font-weight: bold;
  font-size: 16px;
`;

const ActionButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  margin-top: 8px;
`;

const CancelButton = styled.div`
  padding: 10px;
  text-align: center;
  background: #292d2e;
  border: 1px solid rgb(50, 55, 56);
  cursor: pointer;
  color: white;
  font-size: 12px;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const PlaceButton = styled.div`
  padding: 10px;
  text-align: center;
  background: rgb(240, 156, 6);
  border: 1px solid rgb(240, 156, 6);
  cursor: pointer;
  color: black;
  font-size: 12px;
  font-weight: bold;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const AcceptOddsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
  gap: 5px;
  color: white;
  font-size: 10px;
   font-family: 'Montserrat Alternates', sans-serif;
`;

const AcceptOddsCheckbox = styled.input`
  margin: 0;
  cursor: pointer;
`;

const quickAmounts = [100, 1000, 2000, 5000, 50000, 100000];

const InPlayBetMobile = ({ data }) => {
  const [oddsData, setOddsData] = useState([]);
  const [selectedBets, setSelectedBets] = useState({});
  const [betAmounts, setBetAmounts] = useState({});
  const [acceptAnyOdds, setAcceptAnyOdds] = useState({});
  const [betsCount, setBetsCount] = useState(0);
  const { placeBets } = useBetting();

  // NEW: per-bet placing lock
  const [placingKeys, setPlacingKeys] = useState({});

  // ✅ Transform API odds data (same logic as desktop)

  const { getMatchExposure } = useExposure();
  const exposure = getMatchExposure(data.id);
  const transformOddsData = (apiData) => {
    if (!apiData || !apiData.length) return [];

    const market = apiData[0];
    const teams = [];

    if (market.runners[0]) {
      teams.push({
        team: data.team1,
        key: 'team1',
        odds: [
          ...market.runners[0].ex.availableToBack.map(back => ({
            type: 'back',
            value: back.price || '--',
            volume: back.size || 0
          })),
          ...market.runners[0].ex.availableToLay.map(lay => ({
            type: 'lay',
            value: lay.price || '--',
            volume: lay.size || 0
          }))
        ]
      });
    }

    if (market.runners[1]) {
      teams.push({
        team: data.team2,
        key: 'team2',
        odds: [
          ...market.runners[1].ex.availableToBack.map(back => ({
            type: 'back',
            value: back.price || '--',
            volume: back.size || 0
          })),
          ...market.runners[1].ex.availableToLay.map(lay => ({
            type: 'lay',
            value: lay.price || '--',
            volume: lay.size || 0
          }))
        ]
      });
    }

    if (market.runners[2]) {
      teams.push({
        team: "The Draw",
        key: 'draw',
        odds: [
          ...market.runners[2].ex.availableToBack.map(back => ({
            type: 'back',
            value: back.price || '--',
            volume: back.size || 0
          })),
          ...market.runners[2].ex.availableToLay.map(lay => ({
            type: 'lay',
            value: lay.price || '--',
            volume: lay.size || 0
          }))
        ]
      });
    }

    if (market.runners[2]) {
      setBetsCount(3);
    } else {
      setBetsCount(2);
    }

    return teams;
  };

  // Returns the *currently displayed* odds for a given team/type,
  // mirroring the cells you actually render (back: index 0, lay: index 3).
  const getDisplayedOdds = (teamKey, type) => {
    const team = oddsData.find((t) => t.key === teamKey);
    if (!team || !Array.isArray(team.odds)) return null;

    // You render team.odds.slice(0,1) for Back and slice(3,4) for Lay.
    const idx = type === 'back' ? 0 : 3;
    const cell = team.odds[idx];

    if (!cell || cell.value === '--') return null;
    const v = Number(cell.value);
    return Number.isFinite(v) ? v : null;
  };

  // ✅ Fetch odds data periodically
  useEffect(() => {
    const fetchOddsData = async () => {
      try {
        const res = await fetch(`https://bkk07.com/sports/market-odds?market_id=${data.id}`);
        const json = await res.json();
        setOddsData(transformOddsData(json));
      } catch (err) {
        console.error("Error fetching odds:", err);
      }
    };

    fetchOddsData();
    const interval = setInterval(fetchOddsData, 2000);
    return () => clearInterval(interval);
  }, [data.id]);

  // ✅ Handle odds click (dynamic)

  const handleAmountChange = (betKey, amount) => {
    setBetAmounts((prev) => ({
      ...prev,
      [betKey]: amount.toString(),
    }));
  };

  const handleCancelBet = (betKey) => {
    setSelectedBets(prev => {
      const newBets = { ...prev };
      delete newBets[betKey];
      return newBets;
    });

    setBetAmounts(prev => {
      const newAmounts = { ...prev };
      delete newAmounts[betKey];
      return newAmounts;
    });

    setAcceptAnyOdds(prev => {
      const newAccept = { ...prev };
      delete newAccept[betKey];
      return newAccept;
    });
  };
  const handleOddsClick = (teamKey, type, odds) => {
    if (odds.value === '--') return;

    const betKey = `${teamKey}-${type}`;
    const oppositeType = type === 'back' ? 'lay' : 'back';
    const oppositeKey = `${teamKey}-${oppositeType}`;

    setSelectedBets(prev => {
      const newBets = { ...prev };
      if (newBets[betKey]) {
        delete newBets[betKey];
      } else {
        delete newBets[oppositeKey];
        newBets[betKey] = { team: teamKey, type, odds: odds.value, volume: odds.volume };
      }
      return newBets;
    });

    if (!betAmounts[betKey]) {
      setBetAmounts(prev => ({ ...prev, [betKey]: '100' }));
    }
  };

  // Place inside InPlayBetMobile.jsx, above the return()
  const TeamCellN = ({ team, matchTitle, matchId, market = 'MO' }) => {
    const ctx = useBetting() || {};
    const {
      teamValues = {},
      exposures = {},
      placedBets = [],
      getPL = () => 0,
    } = ctx;

    const formatValue = (value) => {
      const n = Number(value);
      if (!Number.isFinite(n) || n === 0) return '';
      return n;
    };

    const teamValue = teamValues?.[team] ?? { left: 0, right: 0 };

    const key = matchId != null ? String(matchId) : String(matchTitle || '');
    const tnorm = String(team || '').trim().toLowerCase();

    const current = exposures[key]?.teams?.[team] ?? 0;
    const local = getPL(market, team) || 0;
    const updated = current;

    const hasPrior =
      Array.isArray(placedBets) &&
      placedBets.some((b) => String(b.matchId ?? b.matchTitle) === key);

    const clsNew = updated < 0 ? 'text-red-600' : 'text-green-600';

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {/* Team name row */}
        <div style={{ fontSize: '12px', fontWeight: 'bold', color: 'white' }}>
          {team}
        </div>

        {/* Old → New exposure */}
        <div className="mt-1 text-[11px] leading-none whitespace-nowrap">
          {hasPrior ? (
            <b
              className={clsNew}
              style={{ color: updated >= 0 ? 'green' : 'red' }}
            >
              {updated > 0 ? '+' : ''}
              {updated.toFixed(2)}
            </b>
          ) : (
            <b
              className={clsNew}
              style={{ color: updated >= 0 ? 'green' : 'red' }}
            >
              {updated > 0 ? '+' : ''}
              {updated.toFixed(2)}
            </b>
          )}
        </div>
      </div>
    );
  };
  const adjustBetAmount = (betKey, adjustment) => {
    setBetAmounts((prev) => {
      const currentAmount = Number(prev[betKey] || 0);
      const newAmount = Math.max(0, currentAmount + adjustment);
      return { ...prev, [betKey]: newAmount.toString() };
    });
  };


  // ✅ Render bet slip container
  const renderBetContainer = (betKey, bet) => {
    const isPlacingThis = Boolean(placingKeys[betKey]);

    return (
      <BetContainer key={betKey} betType={bet.type}>
        <div style={{ fontSize: '12px', color: 'white', textAlign: 'right', margin: "1px 6px" }}>Min Bet</div>
        <div style={{ display: 'flex', gap: '10px', margin: '4px 0', alignItems: 'center' }}>
          <BetInput>{bet.odds}</BetInput>
          <BetInputContainer>
            <AdjustButton onClick={() => adjustBetAmount(betKey, -10)}>−</AdjustButton>
            <BetInputc type="number"
              value={betAmounts[betKey] || ''}
              onChange={(e) => handleAmountChange(betKey, parseFloat(e.target.value) || 0)}
            />
            <AdjustButton onClick={() => adjustBetAmount(betKey, 10)}>+</AdjustButton>
          </BetInputContainer>
        </div>

        {/* Quick Amounts */}
        <QuickAmounts>
          {quickAmounts.map(amount => (
            <QuickAmount key={amount} onClick={() => handleAmountChange(betKey, amount)}>
              {amount}
            </QuickAmount>
          ))}
        </QuickAmounts>

        {/* Action Buttons */}
        <ActionButtons>
          <CancelButton onClick={() => handleCancelBet(betKey)} disabled={isPlacingThis}>
            Cancel
          </CancelButton>

          <PlaceButton
            onClick={async () => {
              // Prevent duplicate placement for the same betKey
              if (placingKeys[betKey]) {
                // optional: show a small notice
                console.warn('Placement already in progress for', betKey);
                return;
              }

              // Basic validation
              const stake = parseFloat(betAmounts[betKey] || '0');
              const oddsNum = parseFloat(bet.odds || '0');
              if (!stake || stake < 4 || !oddsNum || oddsNum <= 1) {
                sendNotfication('Enter valid stake (>=4) and odds (>1).', 'error', 'bottom-left');
                return;
              }

              // Check live odds
              const live = getDisplayedOdds(bet.team, bet.type);
              if (!live) {
                sendNotfication('Odds are unavailable at the moment. Please try again.', 'warning', 'bottom-left');
                return;
              }

              // Compare with small tolerance
              const changed = Math.abs(live - oddsNum) > 1e-9;
              if (changed) {
                setSelectedBets((prev) => {
                  const current = prev[betKey];
                  if (!current) return prev;
                  return { ...prev, [betKey]: { ...current, odds: live } };
                });

                sendNotfication(`Odds have changed from ${oddsNum} to ${live}. Review and place again.`, 'warning', 'bottom-left');
                return;
              }

              // Set lock for this betKey
              setPlacingKeys(prev => ({ ...prev, [betKey]: true }));

              try {
                const betRow = {
                  market: 'MO',
                  matchId: data.id,
                  count: betsCount,
                  eventid: data.eventid,
                  matchTitle: `${data.team1} v ${data.team2}`,
                  selectionName:
                    bet.team === 'team1' ? data.team1 :
                      bet.team === 'team2' ? data.team2 : 'The Draw',
                  category: bet.team === 'draw' ? 'x' : bet.team === 'team1' ? '1' : '2',
                  type: bet.type,
                  odds: oddsNum,
                  stake,
                  liability: bet.type === 'lay' ? stake * (oddsNum - 1) : stake,
                };

                // await the placement
                const result = await placeBets([betRow]);

                if (result?.confirmed?.length > 0) {
                  sendNotfication('Bet placed successfully!', 'success', 'bottom-left');
                  handleCancelBet(betKey);
                } else {
                  sendNotfication(result?.errors?.[0]?.message || 'Bet failed', 'error', 'bottom-left');
                }
              } catch (err) {
                console.error('Error placing bet:', err);
                sendNotfication('An unexpected error occurred while placing the bet.', 'error', 'bottom-left');
              } finally {
                // Release lock
                setPlacingKeys(prev => {
                  const copy = { ...prev };
                  delete copy[betKey];
                  return copy;
                });
              }
            }}
            // disable UI while placing
            style={{ opacity: isPlacingThis ? 0.6 : 1, pointerEvents: isPlacingThis ? 'none' : 'auto' }}
          >
            {isPlacingThis ? 'Placing...' : 'Place Bet'}
          </PlaceButton>
        </ActionButtons>
      </BetContainer>
    );
  };

  return (
    <Container>
      <Header>
        <HeaderTitle><Target size={16} /> Match Odds</HeaderTitle>
        <MatchedInfo>Game Exposure : {Number(exposure).toFixed(2)}</MatchedInfo>
      </Header>

      <Table>
        <TableHeader>
          <HeaderCell></HeaderCell>
          <HeaderCell>Back</HeaderCell>
          <HeaderCell>Lay</HeaderCell>
        </TableHeader>

        {/* ✅ Dynamic Rows */}
        {oddsData.map(team => (
          <React.Fragment key={team.key}>
            <TableRow>
              <TeamCell>
                <TeamCellN
                  team={team.team}
                  matchTitle={`${data.team1} v ${data.team2}`}
                  matchId={data.id}
                />
              </TeamCell>
              {team.odds.slice(0, 1).map((odd, i) => (
                <OddsCell
                  key={i}
                  type="back"
                  onClick={() => handleOddsClick(team.key, 'back', odd)}
                  selected={selectedBets[`${team.key}-back`]}
                >
                  <span className="odds">{odd.value}</span>
                  <span className="volume">{odd.volume}</span>
                </OddsCell>
              ))}
              {team.odds.slice(3, 4).map((odd, i) => (
                <OddsCell
                  key={i}
                  type="lay"
                  onClick={() => handleOddsClick(team.key, 'lay', odd)}
                  selected={selectedBets[`${team.key}-lay`]}
                >
                  <span className="odds">{odd.value}</span>
                  <span className="volume">{odd.volume}</span>
                </OddsCell>
              ))}

            </TableRow>

            {/* ✅ Bet Container per team */}
            {Object.entries(selectedBets)
              .filter(([key]) => key.startsWith(team.key))
              .map(([betKey, bet]) => renderBetContainer(betKey, bet))}
          </React.Fragment>
        ))}
      </Table>
    </Container>
  );
};

export default InPlayBetMobile;